import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { DeviceDetailSaveEvent } from '../models/device-detail-form-submit-event';
import { DeviceDetailView } from '../models/device-detail-view.model';
import { SaveDevice } from '../queries/generated/SaveDevice';
import { BaseStationHandsetItemView } from '../views/models/handset-item-view.model';

export const deviceDetailLoad = createAction('[Device Detail] Load');

export const deviceDetailCancel = createAction('[Device Detail] Cancel');

export const loadDeviceDetailSuccess = createAction('[API] Load Device Success', props<{ data: DeviceDetailView }>());

export const loadSystemDeviceDetailsSuccess = createAction(
   '[API] Load System Device Success',
   props<{ data: DeviceDetailView }>()
);

export const loadDeviceAccessDenied = createAction('[API] Load Device Access Denied');

export const deleteDevice = createAction('[Device Detail] Delete Device', props<{ deviceId: number }>());

export const deleteDeviceSuccess = createAction('[Device Detail] Delete Device Success', props<{ deviceId: number }>());

export const deleteDeviceFailure = createAction('[Device Detail] Delete Device Failure', props<SingleGraphError>());

export const loadDeviceDetailFailure = createAction('[API] Load Device Failure', props<SingleGraphError>());

export const saveDeviceDetail = createAction('[Device Detail] Save', props<DeviceDetailSaveEvent>());

export const releaseDeviceDetail = createAction('[Device Detail] Release', props<DeviceDetailSaveEvent>());

export const releaseDeviceDetailSuccess = createAction(
   '[Device Detail] Release Success',
   props<{ data: SaveDevice }>()
);

export const releaseDeviceDetailFailure = createAction('[Device Detail] Release Failure', props<SingleGraphError>());

export const releaseDeviceToAccount = createAction('[Device Detail] Release To Account', props<{ deviceId: number }>());

export const releaseDeviceToAccountSuccess = createAction(
   '[Device Detail] Release To Account Success',
   props<{ data: SaveDevice }>()
);

export const releaseDeviceToAccountFailure = createAction(
   '[Device Detail] Release To Account Failure',
   props<SingleGraphError>()
);

export const saveDeviceDetailSuccess = createAction('[Device Detail] Save Success', props<{ data: SaveDevice }>());

export const saveDeviceDetailFailure = createAction('[Device Detail] Save Failure', props<SingleGraphError>());

export const changeSipUserPasswords = createAction(
   '[Device Detail] Change Sip User Passwords',
   props<{ sipUserIds: number[] }>()
);

export const changeSipUserPasswordSuccess = createAction('[Device Detail] Change Sip User Password Success');

export const changeSipUserPasswordFailure = createAction(
   '[Device Detail] Change Sip User Password Failure',
   props<SingleGraphError>()
);

export const addNewBaseStationStep = createAction('[Device Detail] Add New Base Station Step');

export const addNewBaseStationStepSubmit = createAction(
   '[Extension Detail FmFm Step Dialog] Submit',
   props<{ baseStationStepItem: BaseStationHandsetItemView }>()
);

export const confirmDeviceChange = createAction('[Device Detail] Confirm Device Change');

export const deviceRouteCorrected = createAction('[Device Detail] Route Corrected');
